// models
import { UserRole } from 'enums';
import type { UserCombinedInfo, UserDetailInfo } from '../models/user.model';

// modules
import { persistAtom } from 'modules';

// libraries
import { atom } from 'recoil';

/** 로그인한 사용자 ID */
export const UserIdAtom = atom<string | null>({
  key: 'UserIdAtom',
  default: null,
  effects_UNSTABLE: [persistAtom]
});

/** 로그인한 사용자 권한 */
export const UserRolesAtom = atom<UserRole | null>({
  key: 'UserRolesAtom',
  default: null,
  effects_UNSTABLE: [persistAtom]
});

/** 로그인한 사용자 정보 */
export const UserInfoAtom = atom<UserDetailInfo | undefined>({
  key: 'UserInfoAtom',
  default: undefined,
  effects_UNSTABLE: [persistAtom]
});

/** 관리자가 관리자 등록 정보 */
export const RegisterManagerAtom = atom<UserCombinedInfo | null>({
  key: 'RegisterManagerAtom',
  default: null
});
